import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, Link } from "react-router-dom";
import { ArrowBendDownRightIcon, SignOutIcon } from "@phosphor-icons/react";

import Icon from "components/Icon/Icon";
import CommonTooltip from "components/Tooltip/index";

import {
  DashboardProfileLogo,
  IconLinkStyled,
  IconSvgWrapper,
  IconsWrapperStyles,
  IconTextStyled,
  MenuListWrapper,
  ProfileModalWrapper,
  Separator
} from "components/SideBar/styled";

import { LoginActions, useLoginSlice } from "./slice/index";

import hashfameLogo from "assets/svg/hashfame-icon.svg";
import { menuItems } from "./data";

import { selectUser } from "store/auth/slice/selector";
import { DEFAULT_PROFILE_IMG } from "utils/helper";

// Active/Inactive icon colors
const ACTIVE_COLOR = "#A049FC";

const SideBar = ({ isHovered }) => {
  const { user } = useSelector(selectUser);
  const dispatch = useDispatch();
  const { actions } = useLoginSlice();
  const location = useLocation();
  const currentPath = location.pathname;

  const handleLogout = () => {
    dispatch(actions.logoutRequest());
  };

  return (
    <>
      <DashboardProfileLogo $isHovered={isHovered}>
        <img
          src={hashfameLogo}
          alt="main-logo"
          className="main-image"
          height={24}
          width={24}
        />
        <div className="profile-logo-wrapper">
          <div className="profile-logo-name">
            <h2>HashFame</h2>
          </div>
        </div>
      </DashboardProfileLogo>

      <Separator $isHovered={isHovered} />

      {/* ---------- Navigation Icons (Menu) ---------- */}
      <IconsWrapperStyles>
        <div className="first-set-icons-wrapper">
          {menuItems?.map(({ path, label, icon, subMenus, isSubMenu }) => {
            const active =
              currentPath === path || currentPath.startsWith(path + "/");

            return isSubMenu ? (
              <MenuListWrapper key={label}>
                <IconLinkStyled className="sub-menu-parent">
                  <IconSvgWrapper>
                    <Icon component={icon} color={"#1F1F1F"} />
                  </IconSvgWrapper>
                  <IconTextStyled $isHovered={isHovered}>
                    {label}
                  </IconTextStyled>
                </IconLinkStyled>

                <div className="sub-menu-list-wrapper">
                  {isSubMenu &&
                    subMenus?.map((menuItem) => {
                      const subActive =
                        currentPath === menuItem.path ||
                        currentPath.startsWith(menuItem.path + "/");

                      return (
                        <IconLinkStyled
                          as={Link}
                          to={menuItem.path}
                          key={menuItem.path}
                          $isHovered={isHovered}
                          className={subActive ? "active" : ""}
                        >
                          <IconSvgWrapper>
                            <Icon
                              component={ArrowBendDownRightIcon}
                              color={subActive ? ACTIVE_COLOR : "#1F1F1F"}
                            />
                          </IconSvgWrapper>
                          <IconTextStyled $isHovered={isHovered}>
                            {menuItem.label}
                          </IconTextStyled>
                        </IconLinkStyled>
                      );
                    })}
                </div>
              </MenuListWrapper>
            ) : (
              <IconLinkStyled
                as={Link}
                to={path}
                key={path}
                $isHovered={isHovered}
                className={active ? "active" : ""}
              >
                <IconSvgWrapper>
                  <Icon
                    component={icon}
                    color={active ? ACTIVE_COLOR : "#1F1F1F"}
                  />
                </IconSvgWrapper>
                <IconTextStyled $isHovered={isHovered}>{label}</IconTextStyled>
              </IconLinkStyled>
            );
          })}
        </div>
      </IconsWrapperStyles>

      <Separator $isHovered={isHovered} />

      <ProfileModalWrapper $isHovered={isHovered}>
        <img
          src={user?.google_picture}
          alt={user?.full_name}
          className="profile-image"
          height={28}
          onError={(e) => (e.currentTarget.src = DEFAULT_PROFILE_IMG)}
          width={28}
        />

        <div className="profile-details">
          <h2 className="user-name">{user?.full_name}</h2>
          <p className="user-email">{user?.email}</p>
        </div>

        <CommonTooltip theme="dark" tooltipContent="Sign Out">
          <div className="sign-out-icon" onClick={handleLogout}>
            <Icon component={SignOutIcon} color={"#1F1F1F"} />
          </div>
        </CommonTooltip>
      </ProfileModalWrapper>
    </>
  );
};

export default SideBar;
